import { ROUTES } from '@/config/routes';
import { UserGroup } from '@/types/groups';
export interface MenuItem {
  title: string;
  link?: string;
  ico?: string;
  submenu?: MenuItem[];
  open?: boolean;
  onClick?: (event?: React.MouseEvent) => void;
  active?: () => boolean;
  external?: boolean;
  allowedGroups?: UserGroup[];
  hiddenFromGroups?: UserGroup[];
}

export const useMenu = (): MenuItem[] => {
  const menu: MenuItem[] = [
    {
      title: 'Приложения',
      ico: 'apps',
      active: () =>
        window.location.pathname.startsWith(ROUTES.ADMIN.APPLICATION_GROUPS) ||
        window.location.pathname.startsWith(ROUTES.ADMIN.APPLICATIONS) ||
        window.location.pathname.startsWith(ROUTES.ADMIN.APPLICATION_LINKS),
      submenu: [
        {
          title: 'Группы приложений',
          link: ROUTES.ADMIN.APPLICATION_GROUPS,
          ico: 'groups-list',
          active: () => window.location.pathname.startsWith(ROUTES.ADMIN.APPLICATION_GROUPS),
        },
        {
          title: 'Приложения',
          link: ROUTES.ADMIN.APPLICATIONS,
          ico: 'apps',
          active: () => window.location.pathname.startsWith(ROUTES.ADMIN.APPLICATIONS),
        },
        {
          title: 'Ссылки на документы',
          link: ROUTES.ADMIN.APPLICATION_LINKS,
          ico: 'links',
          active: () => window.location.pathname.startsWith(ROUTES.ADMIN.APPLICATION_LINKS),
        },
      ],
      allowedGroups: [UserGroup.Applications],
    },
    {
      title: 'Чаты',
      ico: 'chats',
      active: () =>
        window.location.pathname.startsWith(ROUTES.ADMIN.CHATS) ||
        window.location.pathname.startsWith(ROUTES.ADMIN.CHATS_GROUPS) ||
        window.location.pathname.startsWith(ROUTES.ADMIN.CHATS_TEMPLATES),
      submenu: [
        {
          title: 'Чаты',
          link: ROUTES.ADMIN.CHATS,
          ico: 'chats',
          active: () => window.location.pathname.startsWith(ROUTES.CHATS.BASE),
        },
        {
          title: 'Группы чатов',
          link: ROUTES.ADMIN.CHATS_GROUPS,
          ico: 'groups-list',
          active: () => window.location.pathname.startsWith(ROUTES.ADMIN.CHATS_GROUPS),
        },
        {
          title: 'Шаблоны чатов',
          link: ROUTES.ADMIN.CHATS_TEMPLATES,
          ico: 'variation-spark',
          active: () => window.location.pathname.startsWith(ROUTES.ADMIN.CHATS_TEMPLATES),
        },
        {
          title: 'Отправка сообщения',
          link: ROUTES.ADMIN.SEND_MESSAGE,
          ico: 'send-message',
          active: () => window.location.pathname.startsWith(ROUTES.ADMIN.SEND_MESSAGE),
        },
      ],
      allowedGroups: [UserGroup.Chats],
    },
    {
      title: 'Группы пользователей',
      link: ROUTES.ADMIN.USER_GROUPS,
      ico: 'user-groups',
      active: () => window.location.pathname.startsWith(ROUTES.ADMIN.USER_GROUPS),
      allowedGroups: [UserGroup.UserGroups],
    },
  ];

  return menu;
};
